import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  deskModuleTabActive,
  type DeskModuleTab,
} from "./desk-module-tabs";
import {
  deskSegmentItemClass,
  deskSegmentListClass,
  deskSegmentNavClass,
} from "./desk-segment";

/** Calm segment control for sibling Desk list views — plan/35. */
export function DeskSubNav(props: {
  items: readonly DeskModuleTab[];
  className?: string;
  /**
   * `below` — under the title (legacy).
   * `header` — in the page header action cluster (ERPNext-style).
   */
  placement?: "below" | "header";
  "aria-label"?: string;
}) {
  const { pathname } = useLocation();
  const items = props.items;
  const placement = props.placement ?? "below";

  if (items.length === 0) return null;

  return (
    <nav
      aria-label={props["aria-label"] ?? "Module views"}
      className={deskSegmentNavClass(
        placement === "header"
          ? "mt-0 max-w-[min(100vw-8rem,28rem)]"
          : undefined,
        props.className,
      )}
    >
      <div className={deskSegmentListClass()} role="tablist">
        {items.map((item) => {
          const active = deskModuleTabActive(pathname, item, items);
          return (
            <Link
              key={item.id}
              to={item.to}
              role="tab"
              aria-selected={active}
              className={cn(deskSegmentItemClass(active), "no-underline")}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
